import type { RoomPromptSettings } from '../types/interiorAI'

export function buildInteriorPrompt(settings: RoomPromptSettings): string {
  const { roomLabel, styleLabel, colorLabel, budgetLabel } = settings
  return [
    `You are a professional interior designer and a photorealistic architectural rendering engine.`,
    `Redesign the room in the attached photo into a ${roomLabel} styled as "${styleLabel}".`,
    `Use a ${colorLabel} color palette as the dominant tone across walls, textiles and accents.`,
    `Keep the room's architecture identical — same walls, windows, doors and camera angle — but replace furniture, decor, lighting fixtures, flooring and wall finishes to match the new style.`,
    `The estimated renovation budget is around ${budgetLabel}, so keep material and furniture choices realistic for that price range.`,
    `Output a single photorealistic image shot like a professional real-estate photograph: natural lighting, sharp focus, high detail. Do not include people, text or watermarks.`,
  ].join(' ')
}
